<main class="main-home-secton">
  <div class="bg">
    <div class="container">
      <div class="header ml-4"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 tab-view">
            <img src="assets/images/login.png" alt="" class="img-fluid" />
          </div>
          <div class="col-lg-6 col-md-6 tab-view">
            <div class="login-title">
              <h2>Login</h2>
            </div>
            <div>
              <form action="" [formGroup]="loginForm">
                <div class="form-row mb-3">
                  <mat-form-field class="material-full-width" appearance="fill">
                    <mat-label
                      >User Name <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter User Name"
                      formControlName="username"
                      [ngClass]="{
                        'is-invalid':
                          add.username.touched && add.username.errors
                      }"
                    />
                    <mat-error
                      *ngIf="add.username.touched && add.username.errors"
                    >
                      <span *ngIf="add.username.errors.required"
                        >User Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-row mb-3">
                  <mat-form-field class="material-full-width" appearance="fill">
                    <mat-label
                      >Password <span class="text-danger">*</span></mat-label
                    >
                    <input
                      [type]="showPassword ? 'password' : 'text'"
                      matInput
                      placeholder="Enter Password"
                      formControlName="password"
                      [ngClass]="{
                        'is-invalid':
                          add.password.touched && add.password.errors
                      }"
                    />
                    <mat-icon
                      matSuffix
                      class="c-pointer"
                      (click)="togglePasswordVisibility()"
                    >
                      {{ showPassword ? "visibility_off" : "visibility" }}
                    </mat-icon>
                    <mat-error
                      *ngIf="add.password.touched && add.password.errors"
                    >
                      <span *ngIf="add.password.errors.required"
                        >Password is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                  <span class="forgot" (click)="forget()"
                    >Forgot password?</span
                  >
                </div>
              </form>
            </div>
            <div class="text-center">
              <button class="login-btn" (click)="loginAdmin()">Login</button>
            </div>
            <div class="account text-center mt-3">
              <span
                >Don’t Have an account? <b (click)="openModal()">Register</b>
              </span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mobile-view">
            <div class="login-title">
              <h2>Login</h2>
            </div>
            <div>
              <form action="" [formGroup]="loginForm">
                <div class="form-row mb-3">
                  <mat-form-field class="material-full-width" appearance="fill">
                    <mat-label
                      >User Name <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter User Name"
                      formControlName="username"
                      [ngClass]="{
                        'is-invalid':
                          add.username.touched && add.username.errors
                      }"
                    />
                    <mat-error
                      *ngIf="add.username.touched && add.username.errors"
                    >
                      <span *ngIf="add.username.errors.required"
                        >User Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="form-row mb-3">
                  <mat-form-field class="material-full-width" appearance="fill">
                    <mat-label
                      >Password <span class="text-danger">*</span></mat-label
                    >
                    <input
                      [type]="showPassword ? 'password' : 'text'"
                      matInput
                      placeholder="Enter Password"
                      formControlName="password"
                      [ngClass]="{
                        'is-invalid':
                          add.password.touched && add.password.errors
                      }"
                    />
                    <mat-icon
                      matSuffix
                      class="c-pointer"
                      (click)="togglePasswordVisibility()"
                    >
                      {{ showPassword ? "visibility_off" : "visibility" }}
                    </mat-icon>
                    <mat-error
                      *ngIf="add.password.touched && add.password.errors"
                    >
                      <span *ngIf="add.password.errors.required"
                        >Password is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                  <span class="forgot" (click)="forget()"
                    >Forgot password?</span
                  >
                </div>
              </form>
            </div>
            <div class="text-center">
              <button class="login-btn" (click)="loginAdmin()">Login</button>
            </div>
            <div class="account text-center mt-3">
              <span
                >Don’t Have an account? <b (click)="openModal()">Register</b>
              </span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 mobile-view">
            <img src="assets/images/login.png" alt="" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
